export default __webpack_public_path__ + "static/media/08.8a186b2b.png";